import { useState, useEffect } from 'react';

const STORAGE_KEY = 'tc-theme';

function readInitial() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark') return true;
    if (stored === 'light') return false;
  } catch (e) { /* storage unavailable */ }
  return false; // light is the default when no preference is stored
}

export function useTheme() {
  const [darkMode, setDarkMode] = useState(readInitial);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
    try {
      window.localStorage.setItem(STORAGE_KEY, darkMode ? 'dark' : 'light');
    } catch (e) { /* storage unavailable */ }
  }, [darkMode]);

  return { darkMode, setDarkMode };
}

export default useTheme;
